/**
 * @generated SignedSource<<70c38e954117f2e432c50fff5a9ba3f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type searchContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "searchContentItemContent";
};
export type searchContentItemContent$key = {
  readonly " $data"?: searchContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "searchContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "681d9f59ac551fb4da62ae26fcb6e51b";

export default node;
